import XLSX from "xlsx-js-style";
import { saveAs } from "file-saver";

export const exportRollNoListingExcel = ({
    reportData,
    summReportData,
    instituteName,
    selectedYear1,
    selectedStdName,
    selectedDivName,
}) => {

    const wb = XLSX.utils.book_new();
    const wsData = [];

    //--------------------------------------------------
    // Report Heading
    //--------------------------------------------------

    const yearText = `${selectedYear1}-${Number(selectedYear1) + 1}`;

    wsData.push([instituteName]);
    wsData.push([]);
    wsData.push([`Roll Number Listing for Std / Div : ${selectedStdName} / ${selectedDivName}`]);
    wsData.push([`Academic Year : ${yearText}`]);
    wsData.push([]);

    //--------------------------------------------------
    // Main Header
    //--------------------------------------------------

    wsData.push([
        "Roll No",
        "GR No",
        "Student Name",
        "Address",
        "Birth Date",
        "Student Id",
        "Gender",
        "House"
    ]);

    //--------------------------------------------------
    // Main Data
    //--------------------------------------------------

    reportData.forEach((r) => {

        wsData.push([
            r.roll_no,
            r.gr_no,
            r.stud_name,
            `${r.stud_addr1 || ""} ${r.stud_addr2 || ""}`,
            r.birth_date,
            r.stud_id,
            r.gender,
            r.house
        ]);

    });

    //--------------------------------------------------
    // Blank Row
    //--------------------------------------------------

    wsData.push([]);
    wsData.push(["House Summary"]);
    wsData.push(["House", "Count"]);

    //--------------------------------------------------
    // Summary
    //--------------------------------------------------

    summReportData.forEach((r) => {

        wsData.push([
            r.house,
            r.stud_count
        ]);

    });

    //--------------------------------------------------
    // Worksheet
    //--------------------------------------------------

    const ws = XLSX.utils.aoa_to_sheet(wsData);

    const range = XLSX.utils.decode_range(ws["!ref"]);

    for (let R = range.s.r; R <= range.e.r; ++R) {

        for (let C = range.s.c; C <= range.e.c; ++C) {

            const ref = XLSX.utils.encode_cell({ r: R, c: C });

            if (!ws[ref]) continue;

            ws[ref].s = {
                border: {
                    top: { style: "thin" },
                    bottom: { style: "thin" },
                    left: { style: "thin" },
                    right: { style: "thin" }
                },
                alignment: {
                    vertical: "center",
                    wrapText: true
                }
            };

            // School Name
            if (R === 0) {

                ws[ref].s = {
                    ...ws[ref].s,
                    font: { bold: true, sz: 14 },
                    alignment: {
                        horizontal: "center"
                    }
                };

            }

            // Report Heading
            if (R === 2 || R === 3) {

                ws[ref].s = {
                    ...ws[ref].s,
                    font: { bold: true }
                };

            }

            // Main Header
            if (R === 5) {

                ws[ref].s = {
                    ...ws[ref].s,
                    font: { bold: true },
                    fill: {
                        fgColor: { rgb: "E6E6E6" }
                    },
                    alignment: {
                        horizontal: "center"
                    }
                };

            }

            // House Summary Title
            if (ws[ref].v === "House Summary") {

                ws[ref].s = {
                    ...ws[ref].s,
                    font: {
                        bold: true,
                        sz: 12
                    }
                };

            }

            // Summary Header
            if (wsData[R][0] === "House" && wsData[R][1] === "Count") {

                ws[ref].s = {
                    ...ws[ref].s,
                    font: { bold: true },
                    fill: {
                        fgColor: { rgb: "E6E6E6" }
                    },
                    alignment: {
                        horizontal: "center"
                    }
                };

            }

        }

    }

    //--------------------------------------------------
    // Merge Heading
    //--------------------------------------------------

    ws["!merges"] = [

        { s: { r: 0, c: 0 }, e: { r: 0, c: 7 } },
        { s: { r: 2, c: 0 }, e: { r: 2, c: 7 } },
        { s: { r: 3, c: 0 }, e: { r: 3, c: 7 } },
        { s: { r: reportData.length + 7, c: 0 }, e: { r: reportData.length + 7, c: 1 } }

    ];

    //--------------------------------------------------
    // Column Widths
    //--------------------------------------------------

    ws["!cols"] = [

        { wch: 10 }, // Roll
        { wch: 12 }, // GR
        { wch: 28 }, // Name
        { wch: 35 }, // Address
        { wch: 12 }, // Birth Date
        { wch: 15 }, // Student Id
        { wch: 10 }, // Gender
        { wch: 12 }, // House

    ];

    //--------------------------------------------------
    // Workbook
    //--------------------------------------------------

    XLSX.utils.book_append_sheet(wb, ws, "Roll No Listing");

    const wbout = XLSX.write(wb, {
        bookType: "xlsx",
        type: "array"
    });

    saveAs(
        new Blob([wbout], {
            type: "application/octet-stream"
        }),
        `Roll_Number_Listing_${selectedStdName}_${selectedDivName}_${yearText}.xlsx`
    );

};
